import React from 'react'
import R from 'ramda'
import { message } from 'antd'
export const loadCharTypesCard95 = [
  { key: '1', value: '1', text: '1 - Base Load' },
  { key: '2', value: '2', text: '2 - Periodic Startup' },
  { key: '3', value: '3', text: '3 - Weekly Startup' },
  { key: '4', value: '4', text: '4 - Daily Startup' },
  { key: '5', value: '5', text: '5 - Startup for Peaks' },
  { key: '6', value: '6', text: '6 - Other' },
  { key: '7', value: '7', text: '7 - Seasonal Operation' },
]

export const NEVADAloadCharTypes = loadCharTypesCard95

// export const NEVADAloadCharTypes = [
//   { key: '1', value: '1', text: '1 - Base Load' },
//   { key: '2', value: '2', text: '2 - Periodic Startup' },
//   { key: '3', value: '3', text: '3 - Weekly Startup' },
//   { key: '4', value: '4', text: '4 - Daily Startup' },
//   { key: '5', value: '5', text: '5 - Startup for Peaks' },
//   {
//     key: '6',
//     value: '6',
//     text:
//       '6 - Daily start up with load-following and taken off-line during solar hours',
//   },
//   { key: '7', value: '7', text: '7 - Seasonal Operation' },
// ]

export const loadCharTypesGrid = {
  '1': '1 - Base Load',
  '2': '2 - Periodic Startup',
  '3': '3 - Weekly Startup',
  '4': '4 - Daily Startup',
  '5': '5 - Startup for Peaks',
  '6': '6 - Other',
  '7': '7 - Seasonal Operation',
}

export const eventTypes = [
  {
    key: 'D1',
    value: 'D1',
    text: 'D1',
    description: 'Immediate Forced Derate',
  },
  {
    key: 'D2',
    value: 'D2',
    text: 'D2',
    description: 'Delayed Delayed Forced Derate',
  },
  {
    key: 'D3',
    value: 'D3',
    text: 'D3',
    description: 'Postponed Forced Derate',
  },
  {
    key: 'D4',
    value: 'D4',
    text: 'D4',
    description: 'Unplanned Derating Deferred ',
  },
  { key: 'DE', value: 'DE', text: 'DE', description: 'Derating Extension ' },
  {
    key: 'DM',
    value: 'DM',
    text: 'DM',
    description: 'Maintenance Derate Extension',
  },
  {
    key: 'DP',
    value: 'DP',
    text: 'DP',
    description: 'Planned Derate Extension',
  },
  { key: 'IR', value: 'IR', text: 'IR', description: 'Inactive Reserve' },
  { key: 'MB', value: 'MB', text: 'MB', description: 'Mothball' },
  {
    key: 'ME',
    value: 'ME',
    text: 'ME',
    description: 'Maintenance Outage Extension',
  },
  { key: 'MO', value: 'MO', text: 'MO', description: 'Maintenance Outage' },
  { key: 'NC', value: 'NC', text: 'NC', description: 'Non-Curtailing Event' },
  { key: 'PD', value: 'PD', text: 'PD', description: 'Planned Derating ' },
  {
    key: 'PE',
    value: 'PE',
    text: 'PE',
    description: 'Planned Outage Extension',
  },
  { key: 'PO', value: 'PO', text: 'PO', description: 'Planned Outage' },
  { key: 'RS', value: 'RS', text: 'RS', description: 'Reserve Shutdown' },
  {
    key: 'SE',
    value: 'SE',
    text: 'SE',
    description: 'Scheduled Outage Extension',
  },
  { key: 'SF', value: 'SF', text: 'SF', description: 'Startup Failure' },
  {
    key: 'U1',
    value: 'U1',
    text: 'U1',
    description: 'Immediate Forced Outage',
  },
  { key: 'U2', value: 'U2', text: 'U2', description: 'Delayed Forced Outage' },
  {
    key: 'U3',
    value: 'U3',
    text: 'U3',
    description: 'Unplanned Outage Postponed Postponed Forced Outage',
  },
]

export const conCodes = [
  { key: '1', value: '1', text: 'Primary cause of event' },
  { key: '2', value: '2', text: 'Contributed to primary cause of event' },
  { key: '3', value: '3', text: 'Work done during the event' },
  {
    key: '5',
    value: '5',
    text: 'After startup, delayed unit from reaching load point',
  },
]

export const conCodeMap = R.compose(
  R.fromPairs,
  R.map(e => [e.value, e.value + ' - ' + e.text])
)(conCodes)

export const updateCurrentCardDataAfterSave = (
  allDataList,
  updatedCurCard,
  actionMode
) => {
  const mainCur = updatedCurCard.find(c => c.eventIdx === '1')

  const isSame = (allCur, cur) => {
    return (
      allCur.unit === cur.unit &&
      parseInt(allCur.year) === parseInt(cur.year) &&
      parseInt(allCur.eventNum) === parseInt(cur.eventNum)
    )
  }

  if (actionMode === 'D') {
    return allDataList.filter(d => !isSame(d, mainCur))
  } else if (actionMode === 'I' || actionMode === 'N') {
    return [...allDataList, mainCur]
  } else {
    // edit
    return allDataList.map(d => {
      // some time it has multile record
      const isFound = updatedCurCard.find(f => isSame(d, f))
      if (isFound) return isFound
      else return d
    })
  }
}

const pattern = /[~!@#$%^&*]/g // Not Allowed characters

export const fixDescriptionValue = (
  value,
  showMessage = true,
  withTrim = false
) => {
  if (pattern.test(value)) {
    value = value.replace(pattern, '')
    if (showMessage)
      message.error(
        'The following special characters are not allowed: ~!@#$%^&*'
      )
  }
  value = value.replace(/\t/g, ' ')
  if (withTrim) {
    value = value.trim()
  }
  return value
}
